import { useSyncExternalStore } from "react";
import { getBrandingThemeEpoch, subscribeBrandingTheme } from "../styles/branding";

/**
 * Subscribes to branding theme changes (user toggle, OS preference, or chain-info).
 * Use in Layout or any route outside Layout so `getBrandColors()` updates after theme switches.
 */
export function useBrandingThemeEpoch(): number {
	return useSyncExternalStore(subscribeBrandingTheme, getBrandingThemeEpoch, () => 0);
}
